import React, { useEffect } from 'react'
import { useFormContext, Controller } from 'react-hook-form'
import PropTypes from 'prop-types'

import {
  Box,
  Button,
  Grid,
  MenuItem,
  TextField,
  Typography,
  makeStyles,
} from '@material-ui/core'

import { Label, SelectCountry } from 'components'

import theme from 'theme'
import constants from 'constants/index'
import styles from '../DialogDataTreatment/components/NewForm/styles.js'

const useStyles = makeStyles(styles)

const SharedSoftwareForm = ({
  sharedSoftware,
  index,
  removeSharedSoftware = () => {},
  disabled = false,
}) => {
  const { INTERNATIONAL_SERVER_ALLOCATION_TYPE, BOTH_SERVER_ALLOCATION_TYPE } =
    constants.sharedSoftware

  const { control, errors, setValue, watch, unregister } = useFormContext()
  const classes = useStyles()

  const serverAllocation = watch(`sharedSoftwares[${index}].serverAllocation`)

  const isInternational =
    serverAllocation === INTERNATIONAL_SERVER_ALLOCATION_TYPE ||
    serverAllocation === BOTH_SERVER_ALLOCATION_TYPE

  const softwareAllocationTypeDefaultValue = () => {
    if (
      sharedSoftware.softwareAllocationType ===
      constants.sharedSoftware.COMPANY_ALLOCATION_TYPE
    ) {
      return constants.sharedSoftware.COMPANY_ALLOCATION_ID
    }

    if (
      sharedSoftware.softwareAllocationType ===
      constants.sharedSoftware.THIRDY_ALLOCATION_TYPE
    ) {
      return constants.sharedSoftware.THIRDY_ALLOCATION_ID
    }

    return sharedSoftware.softwareAllocationType
  }

  useEffect(() => {
    setValue(`sharedSoftwares[${index}].name`, sharedSoftware?.name)
    setValue(
      `sharedSoftwares[${index}].softwareAllocationType`,
      softwareAllocationTypeDefaultValue(),
    )
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    if (!isInternational) {
      unregister(`sharedSoftwares[${index}].internationalReason`)
      setValue(`sharedSoftwares[${index}].internationalReason`, '')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isInternational])

  return (
    <Box className={classes.internationalTransferField} p={2}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Box display="flex" flexDirection="column" gridGap={theme.spacing(3)}>
            <Label
              description="Qual o nome da plataforma, software ou aplicativo utilizado?"
              item
            >
              <Controller
                as={
                  <TextField
                    color="primary"
                    className={classes.inputBackground}
                    variant="outlined"
                    disabled={disabled}
                    error={
                      errors?.sharedSoftwares &&
                      !!errors?.sharedSoftwares[index]?.name
                    }
                    helperText={
                      errors?.sharedSoftwares &&
                      errors?.sharedSoftwares[index]?.name &&
                      'Preencha este campo'
                    }
                    fullWidth
                  />
                }
                rules={{ required: true }}
                defaultValue={sharedSoftware.name || ''}
                control={control}
                name={`sharedSoftwares[${index}].name`}
              />
            </Label>

            <Label
              description="O servidor dessa plataforma, software ou aplicativo, é de propriedade da sua empresa ou é contratado, de terceiro?"
              item
            >
              <Controller
                as={
                  <TextField
                    select
                    className={classes.inputBackground}
                    variant="outlined"
                    disabled={disabled}
                    error={
                      errors.sharedSoftwares &&
                      !!errors?.sharedSoftwares[index]?.softwareAllocationType
                    }
                    helperText={
                      errors?.sharedSoftwares &&
                      errors?.sharedSoftwares[index]?.softwareAllocationType &&
                      'Preencha este campo'
                    }
                    fullWidth
                  >
                    <MenuItem value={1}>
                      <Typography>É da minha empresa</Typography>
                    </MenuItem>
                    <MenuItem value={2}>
                      <Typography>É contratado de terceiros</Typography>
                    </MenuItem>
                  </TextField>
                }
                rules={{ required: true }}
                control={control}
                defaultValue={softwareAllocationTypeDefaultValue()}
                name={`sharedSoftwares[${index}].softwareAllocationType`}
              />
            </Label>

            <Label
              description="O servidor é nacional, internacional ou ambos?"
              item
            >
              <Controller
                as={
                  <TextField
                    select
                    className={classes.inputBackground}
                    color="primary"
                    variant="outlined"
                    disabled={disabled}
                    error={
                      !!errors?.sharedSoftwares &&
                      errors?.sharedSoftwares[index]?.serverAllocation
                    }
                    helperText={
                      errors?.sharedSoftwares &&
                      errors?.sharedSoftwares[index]?.serverAllocation &&
                      'Preencha este campo'
                    }
                    fullWidth
                  >
                    <MenuItem
                      value={
                        constants.sharedSoftware.NATIONAL_SERVER_ALLOCATION_TYPE
                      }
                    >
                      <Typography>
                        {
                          constants.sharedSoftware
                            .NATIONAL_SERVER_ALLOCATION_LABEL
                        }
                      </Typography>
                    </MenuItem>
                    <MenuItem
                      value={
                        constants.sharedSoftware
                          .INTERNATIONAL_SERVER_ALLOCATION_TYPE
                      }
                    >
                      <Typography>
                        {
                          constants.sharedSoftware
                            .INTERNATIONAL_SERVER_ALLOCATION_LABEL
                        }
                      </Typography>
                    </MenuItem>
                    <MenuItem
                      value={
                        constants.sharedSoftware.BOTH_SERVER_ALLOCATION_TYPE
                      }
                    >
                      <Typography>
                        {constants.sharedSoftware.BOTH_SERVER_ALLOCATION_LABEL}
                      </Typography>
                    </MenuItem>
                  </TextField>
                }
                rules={{ required: true }}
                defaultValue={sharedSoftware.serverAllocation || ''}
                control={control}
                name={`sharedSoftwares[${index}].serverAllocation`}
              />
            </Label>
          </Box>
        </Grid>

        {isInternational && (
          <Grid item xs={12}>
            <Label
              description="Explique o motivo da transferência internacional"
              item
            >
              <Controller
                as={
                  <TextField
                    className={classes.inputBackground}
                    color="primary"
                    variant="outlined"
                    disabled={disabled}
                    error={
                      !!errors?.sharedSoftwares?.[index]?.internationalReason
                    }
                    helperText={
                      errors?.sharedSoftwares?.[index]?.internationalReason &&
                      'Preencha este campo'
                    }
                    fullWidth
                  />
                }
                rules={isInternational ? { required: true } : {}}
                name={`sharedSoftwares[${index}].internationalReason`}
                defaultValue={sharedSoftware?.internationalReason || ''}
                control={control}
              />
            </Label>
          </Grid>
        )}

        {isInternational && (
          <Grid item xs={12}>
            <SelectCountry
              withTable
              manyFields
              disabled={disabled}
              label="Qual o país destinatário?"
              fieldName={`sharedSoftwares-${index}`}
              indexField={index}
            />
          </Grid>
        )}

        <Controller
          as={<></>}
          name={`sharedSoftwares[${index}].id`}
          control={control}
          defaultValue={sharedSoftware?.id}
        />

        {!disabled && (
          <Grid item xs={12}>
            <Box display="flex" justifyContent="flex-end">
              <Button
                variant="contained"
                color="secondary"
                className={classes.removeButton}
                onClick={() => removeSharedSoftware(index, sharedSoftware)}
              >
                Remover
              </Button>
            </Box>
          </Grid>
        )}
      </Grid>
    </Box>
  )
}

SharedSoftwareForm.propTypes = {
  sharedSoftware: PropTypes.object,
  index: PropTypes.number,
  removeSharedSoftware: PropTypes.func,
  disabled: PropTypes.bool,
}

export default SharedSoftwareForm
